var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaflet-title"},[_c('div',{staticClass:"leaflet-title-header"},[_c('div',{staticClass:"leaflet-title-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"leaflet-title-solt"},[_vm._t("default")],2)]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaflet-title-bottom"},[_c('div',{staticClass:"leaflet-title-block"}),_c('div',{staticClass:"leaflet-title-line"})])
}]

export { render, staticRenderFns }